import { dateFormatter, getAge } from './helpers';

export const getAgeFromDateInMonths = (date) => {
    return getAge(dateFormatter(date), { timeUnit: 'months' });
};

export function splitISODate(isoString) {
    if (typeof isoString !== 'string') return null;

    const isoStringMatch = isoString.match(/^(\d{4})-(\d{2})-(\d{2}).*$/);
    if (!isoStringMatch) return null;

    const [, year = '', month = '', day = ''] = isoStringMatch;
    return {
        day,
        month,
        year
    };
}
